import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { GlobalService } from '../../../../global.service';
import { EventsService } from '../../../events.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-tournament-template',
  templateUrl: './tournament-template.component.html',
  styleUrls: ['./tournament-template.component.css']
})
export class TournamentTemplateComponent implements OnInit , OnChanges{
  @Input() gameName: string;
  constructor(public globalService: GlobalService, public eventService: EventsService, private activeRoute: ActivatedRoute) {
  }
  
  ngOnInit() {
    this.activeRoute.params.subscribe(param => {
      this.changeRoute(param['code']);
    });
  }

  ngOnChanges(changes:SimpleChanges) {
    if(changes['gameName']) {
      this.changeRoute(null);
    }
  }

  changeRoute(param) {
    if(this.gameName){
      this.eventService.loadEventTournaments = true;
      this.eventService.getEventTournaments('spring-break', 1, this.gameName).subscribe(res => {
          this.eventService.eventTournaments.next(res);
          this.eventService.loadEventTournaments = false;
        }, error => {
          this.eventService.eventTournaments.next({data: []});
          this.eventService.loadEventTournaments = false;
        });
    }
  }

}
